module.exports = __webpack_public_path__ + "static/media/sg.5049744e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sg.svg
// module id = 2206
// module chunks = 0